
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116.2 131.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M76.2 0v11l-7.8 21.3 3.8 1.4H60.8l3.8-1.4L56.8 11V0h19.4zm-26 37.5l10.7-3.9h-4V11L53.1.7 34.9 7.3l3.8 10.3L53.2 35l-3 2.5zm-8.1 6.7l8.7-7.3-4.4 2-7.8-21.3-7.1-8.4-14.7 12.4 7.1 8.4 19.6 11.3-1.4 2.9zm-6.3 10.4l5.7-9.8-3.1 2.6L23.8 30l-9.5-5.5-9.6 16.8 9.5 5.5 22.3 3.9-.7 3.9zm-2 11.2l2-11.2-2 3.5-19.6-11.3-10.8-1.9-3.4 19 10.8 1.9 22.3-3.9.7 3.9zm2 11.2l-2-11.2-.7 3.9-22.3-3.9L0 67.7l3.4 19 10.8-1.9 19.6-11.3 2 3.5zm5.7 9.8L35.8 77l.7 3.9-22.3 3.9-9.5 5.5 9.7 16.7 9.5-5.5 14.6-17.4 3 2.7zm8.7 7.3l-8.7-7.3 2 3.5-19.6 11.3-7.1 8.4 14.8 12.4 7.1-8.4 7.8-21.3 3.7 1.4zm32.6-56.6l11.8 9.9 21.6-25.8-14.8-12.4-7.1 8.4-7.8 21.3-3.7-1.4zM60.8 98l-10.7-3.9 3.1 2.6L38.7 114l-3.8 10.3 18.2 6.6 3.8-10.3V98h3.9zm11.4-64.3l10.7 3.9-3.1-2.6 14.6-17.4 3.8-10.3L79.9.7 76.2 11v22.7h-4zm10.6 60.4L72.2 98h4v22.7L80 131l18.2-6.6-3.9-10.4-14.5-17.3 3-2.6zm0 0l3.8-1.4 7.8 21.3 7.1 8.4 14.8-12.4-21.7-25.8-11.8 9.9zM72.2 98H60.8l3.8 1.4-7.8 21.3v11h19.3v-11l-7.8-21.3 3.9-1.4z","fill":"#fff"}})])
          )
        }
      }
    